module.exports = __webpack_public_path__ + "img/es.4cab0763.svg";